export default {
    items: {
        data: []
    },

    items_client: {
        data: []
    }
}